<template lang="pug">

div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    Query.grid.is-tablet-4(
      :query="require('~/graphql/Career.gql').Careers"
      :limit="10"
      :initialValue="careers"
      :variables="({ first, after }) => ({ first, after, isPublished: true,isArchived: true })"
      v-slot="{ items }"
    )
      AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
        AppCard(:img="item.thumb ? [{ srcset: item.thumb, type: 'image/jpg', ratio }] : [{ srcset: '{CDN_URL}/default@2x.jpg 2x, {CDN_URL}/default.jpg 1x', type: 'image/jpg' }]" :ratio="ratio" :title="item.title" :excerpt="item.description" :url="`/careers/${item.slug}`")

</template>

<script>
import { Careers } from '~/graphql/Career.gql';
import Query from '~/components/Query';
import AsymetricGrid from '~/components/PsudoRandomGrid';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: '{CDN_URL}/share/careers.jpg'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: '{CDN_URL}/share/careers.jpg'
        }
      ]
    };
  },
  components: {
    Query,
    AsymetricGrid
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Careers,
      variables: {
        first: 10,
        isPublished: true,
        isArchived: true
      }
    });

    return { careers: data.careers };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Careers archive",
    "pageDesc":"Previously available opportunities.",
    "mantra":"Previously available opportunities."
  },
  "ar": {
    "pageTitle":"الفرص المتاحة",
    "pageDesc":"قم بالاطلاع على كل الفرص المتاحة داخل بيانات وتقدم للانضمام إلى فريقنا.",
    "mantra":"الوظائف التى كانت متاحة."
  }
}
</i18n>
